module.exports = __webpack_public_path__ + "img/icon-excel.d0dd5f99.jpg";